<template>
	<div class="main">
		<div class="naverwebtoon">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<a href=""><img src="../assets/image/naverwebtoon_bigbanner.png" alt=""></a>
		</div>
		<div class="box">
			<Header ref="header"></Header>
			<img class="loading" :src="gameData.topBgImage" alt="">
			<div class="item_Options points-item_Options">
				<div class="content points-content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="describe">
						<img src="../assets/image/publicize.png" alt="">
						<span>|</span>
						<p class="marquee"><span>{{ $t('pointsDescribeText') }}</span></p>
					</div>
					<div class="position">
						<!-- 登录奖励 -->
						<div class="rewards-header">
							<div style="display: flex;align-items: end;gap: 1ch;">
								<h2 class="rewards-title">登錄獎勵</h2>
								<p>登錄後即可領取獎勵</p>
							</div>
							<div class="rewards-actions">
								<button class="action-btn primary">升級寶典</button>
								<button class="action-btn darkblue">補簽獎勵</button>
								<button class="action-btn lightblue">領取明細</button>
								<button class="action-btn lightyellow">活動說明</button>
							</div>
						</div>
						<div class="position-conter">
							<div class="login-rewards">
								<div class="login-rewards-grid">
									<div class="reward-card" v-for="(pair, idx) in rewardPairs" :key="idx">
										<div class="card-header">{{ pair.top.day }}</div>
										<div class="card-body">
											<img class="card-image" src="@/assets/image/logo.png" alt="奖励图标" />
											<div class="card-desc">
												{{ pair.top.title }}<br />
												{{ pair.top.desc }}
											</div>
										</div>
										<button class="reward-btn"
											:class="pair.top.status === '未领取' ? 'unclaimed' : 'claimed'">
											{{ pair.top.status }}
										</button>
										<div class="card-bottom red-box">
											<div class="card-body">
												<img class="card-image" src="@/assets/image/logo.png" alt="奖励图标" />
												<div class="card-desc">
													{{ pair.bottom.title }}<br />
													{{ pair.bottom.desc }}
												</div>
											</div>
											<button class="reward-btn"
												:class="pair.bottom.status === '未领取' ? 'unclaimed' : 'claimed'">
												{{ pair.bottom.status }}
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 积分商城 -->
						<div class="rewards-header" style="display: inline;">
							<div style="display: flex;align-items: end;gap: 1ch;">
								<h1 class="rewards-title">積分商城</h1>
								<p>積分：0</p>
							</div>
							<div class="rewards-actions" style="margin-top: 10px;">
								<button class="action-btn primary">全部</button>
								<button class="action-btn lightblue">遊戲道具</button>
								<button class="action-btn lightyellow">限定時装</button>
							</div>
						</div>
						<div class="points-grid">
							<div class="points-card" v-for="product in pointsProducts" :key="product.id">
								<div class="points-body">
									<img class="points-image" :src="require('@/assets/image/' + product.image)"
										:alt="product.name" />
									<div class="points-desc">
										{{ product.name }}
									</div>
								</div>
								<button class="reward-btn">
									{{ product.points }}點
								</button>
							</div>
						</div>
					</div>
				</div>
				<Footer></Footer>
			</div>
			<TipsWindow ref="tips"></TipsWindow>
			<RewardPopup ref="rewardPopup"></RewardPopup>
		</div>
	</div>
</template>

<script>
import $ from 'jquery'
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import RewardPopup from '../components/RewardPopup.vue'
import TipsWindow from '../components/tipsWindow.vue'
import axios from 'axios'
import {
	isEmpty
} from '../utils/index.js'
import {
	getPointsJsonUrl
} from '../utils/api/index.js'
export default {
	name: 'index',
	components: {
		Header,
		Footer,
		UserInfo,
		RewardPopup,
		TipsWindow
	},
	data() {
		return {
			pointsList: [],
			balance: 0,
			gameData: this.$store.state.gameData,
			hasLogin: this.$session.hasLogin(),
			topRewards: [
				{
					day: '第一天',
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					day: '第二天',
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					day: '第三天',
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					day: '第四天',
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					day: '第五天',
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					day: '第六天',
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					day: '第七天',
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					day: '第八天',
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				}
				// 继续添加更多天的数据
			],
			// 下数据数组（示例）
			bottomRewards: [
				{
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				},
				{
					image: 'logo.png',
					title: '「桃園結義」頭像框',
					desc: '屬性：前鋒軍兵力各加50',
					status: '未领取'
				}
				// 与上数据按索引一一对应
			],
			// 积分商品数据
			pointsProducts: [
				{
					id: 1,
					image: 'logo.png',
					name: '珍貴道具A',
					points: 100,
					status: '可兌換'
				},
				{
					id: 2,
					image: 'logo.png',
					name: '稀有裝備B',
					points: 250,
					status: '可兌換'
				},
				{
					id: 3,
					image: 'logo.png',
					name: '限時時裝C',
					points: 500,
					status: '可兌換'
				},
				{
					id: 4,
					image: 'logo.png',
					name: '高級材料D',
					points: 120,
					status: '可兌換'
				},
				{
					id: 5,
					image: 'logo.png',
					name: '特殊坐騎E',
					points: 800,
					status: '可兌換'
				},
				{
					id: 6,
					image: 'logo.png',
					name: '神祕寶箱F',
					points: 300,
					status: '可兌換'
				},
				{
					id: 7,
					image: 'logo.png',
					name: '強化石G',
					points: 180,
					status: '可兌換'
				},
				{
					id: 8,
					image: 'logo.png',
					name: '技能書H',
					points: 420,
					status: '可兌換'
				},
				{
					id: 9,
					image: 'logo.png',
					name: '寵物食物I',
					points: 90,
					status: '可兌換'
				},
				{
					id: 10,
					image: 'logo.png',
					name: 'VIP體驗J',
					points: 1000,
					status: '可兌換'
				},
				{
					id: 11,
					image: 'logo.png',
					name: '經驗加成K',
					points: 150,
					status: '可兌換'
				},
				{
					id: 12,
					image: 'logo.png',
					name: '金幣包L',
					points: 75,
					status: '可兌換'
				},
				{
					id: 13,
					image: 'logo.png',
					name: '稱號M',
					points: 600,
					status: '可兌換'
				},
				{
					id: 14,
					image: 'logo.png',
					name: '傳送卷N',
					points: 50,
					status: '可兌換'
				},
				{
					id: 15,
					image: 'logo.png',
					name: '禮包O',
					points: 350,
					status: '可兌換'
				}
			],
		}
	},
	computed: {
		// 将上/下数据按索引配对，保证两块内容在同一个 reward-card 中渲染
		rewardPairs() {
			const size = Math.min(this.topRewards.length, this.bottomRewards.length);
			return Array.from({ length: size }).map((_, i) => ({
				top: this.topRewards[i],
				bottom: this.bottomRewards[i]
			}));
		}
	},
	mounted() {
		// this.loadPointsList();
		// this.changeBackground(this.gameData.bottomBgImage);
		// if (this.hasLogin) {
		// 	this.loadPointsData();
		// }
	},
	methods: {
		// loadPointsList: function () {
		// 	let _this = this;
		// 	axios.get(getPointsJsonUrl(this.gameData.gameCode))
		// 		.then((response) => {
		// 			_this.pointsList = response.data;
		// 		});
		// },
		// loadPointsData: function () {
		// 	let _this = this;
		// 	this.$axios({
		// 		method: 'get',
		// 		url: '/web/api/points/initData',
		// 		params: {
		// 			userId: this.$session.getUserId(),
		// 			gameCode: this.$cache.getGameCode()
		// 		}
		// 	})
		// 		.then(response => {
		// 			if (response.code === 1000) {
		// 				this.balance = response.data.balance;
		// 			}
		// 		})
		// },
		// changeBackground(newPath) {
		// 	document.documentElement.style.setProperty('--bottom-background-url', `url(${newPath})`);
		// },
		// exchangeRewards: function (day, item) {
		// 	let _role = this.$cache.getRoleInfo();
		// 	if (isEmpty(_role)) {
		// 		this.$refs.userInfo.openRoleChooseWindow();
		// 		return;
		// 	}

		// 	if (item.points > this.balance) {
		// 		this.$refs.tips.show(this.$i18n.tc('insufficient_points_text'));
		// 		return;
		// 	}

		// 	document.getElementById('btn_span' + day).style.display = 'none';
		// 	this.$setLoading('btn_' + day, true);

		// 	this.$axios({
		// 		method: 'get',
		// 		url: '/web/api/points/exchange',
		// 		params: {
		// 			userId: this.$session.getUserId(),
		// 			gameCode: this.$cache.getGameCode(),
		// 			serverCode: _role.serverCode,
		// 			roleId: _role.roleId,
		// 			level: item.level
		// 		}
		// 	})
		// 		.then(response => {
		// 			if (response.code === 1000) {
		// 				this.balance = response.data;
		// 				this.$refs.rewardPopup.show({ image: item.icon, describe: item.describe })
		// 			} else if (response.code == 4003) {
		// 				this.$refs.tips.show(this.$i18n.tc('points_limit_tips_text'));
		// 			} else {
		// 				this.$refs.tips.show(response.message);
		// 			}
		// 			this.$setLoading('btn_' + day, false);
		// 			document.getElementById('btn_span' + day).style.display = 'block';
		// 		})
		// },
	}
}
</script>

<style>
.points-content {
	margin-bottom: 1rem;
}

.points-item_Options {
	padding-bottom: 0rem;
}

.points-btn {
	border: 1px solid #FDD100;
	background-color: #fff !important;
	color: #FDD100 !important;
}

.login-rewards {
	position: absolute;
	left: 2.6375rem;
	top: .5375rem;
	width: 80%;
	height: 7.3rem;
	overflow-x: auto;
	/* 添加横向滚动条 */
	overflow-y: hidden;
	/* 隐藏纵向滚动条 */
}

/* 自定义滚动条样式（可选） */
.login-rewards::-webkit-scrollbar {
	height: 8px;
}

.login-rewards::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 4px;
}

.login-rewards::-webkit-scrollbar-thumb {
	background: #c1c1c1;
	border-radius: 4px;
}

.login-rewards::-webkit-scrollbar-thumb:hover {
	background: #a8a8a8;
}

.position-conter {
	position: relative;
	background: url(../assets/image/Loginbonus.png) no-repeat;
	background-size: 100% 100%;
	width: 100%;
	height: 8.625rem;
	margin-bottom: .3rem;
}


.position .rewards-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	font-size: 14px;
	margin-bottom: 12px;
}

.position .rewards-title {
	font-size: 30px;
	font-weight: 600;
	color: #333;
}

.position .rewards-actions {
	display: flex;
	gap: 8px;
}

.position .action-btn {
	border: 1px solid #ddd;
	color: #fff;
	border-radius: .1rem;
	cursor: pointer;
	font-size: .175rem;
	width: 1.275rem;
	text-align: center;
	height: .3875rem;
	line-height: .3875rem;
}

.darkblue {
	background: #216aff;
}

.lightblue {
	background: #21a9ff;
}

.lightyellow {
	background: #ffae21;
}


.position .action-btn.primary {
	background: #ff9f00;
	border-color: #ff9f00;
	color: #fff;
}

.login-rewards-grid {
	display: flex;
	gap: 0.15rem;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
}

.reward-card:last-child {
	gap: 0rem;
	/* 最后一个元素不需要右边距 */
}

.reward-card {
	position: relative;
	width: 2.3625rem;
	height: 7.3rem;
	flex-shrink: 0;
	background: #fff url('../assets/image/rewardbackground.png') no-repeat;
	background-size: 100% 100%;
}

.reward-card.claimed {
	border-color: #6aa7ff;
}

.reward-card.disabled {
	opacity: 0.55;
}

/* 顶部标题条 */
.card-header {
	color: #2F2E2E;
	line-height: .45rem;
	text-align: center;
	font-size: .2375rem;
}

.card-body {
	text-align: center;
	height: 2.2rem;
}

.card-image {
	width: 1.7rem;
	height: 1.7rem;
	object-fit: cover;
	display: inline-block;
}

.card-desc {
	color: #2F2E2E;
	font-size: .175rem;
}

.reward-btn {
	display: block;
	outline: none;
	border: none;
	margin-left: .1375rem;
	margin-top: .3rem;
	width: 2.05rem;
	height: .5rem;
	color: #272727;
	line-height: .5rem;
	border-radius: .1rem;
	font-size: .25rem;
}

.red-box {
	margin-top: .425rem;
}

.red-box .reward-btn {
	margin-top: .5rem;
}

.reward-btn.unclaimed {
	background: #f3c356;
	border-color: #d8a843;
	color: #3b2a00;
}

.reward-btn.claimed-btn {
	background: #4596ff;
	border-color: #2a7ae4;
	color: #fff;
}


/* 积分商城样式 */
.points-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(3.1625rem, 1fr));
	gap: 0.235rem;
	padding: .4125rem;
	margin-top: .3rem;
	width: 100%;
	min-height: 8.0625rem;
	border-radius: .1rem;
	background-color: #fff;
	border: 1px solid #ccc;
	box-sizing: border-box;
	box-shadow: 0 0.05rem 0.15rem rgba(0, 0, 0, 0.1);
}

.points-card {
	width: 3.1625rem;
	height: 3.3875rem;
	background: url(../assets/image/Itembackgroun.png) no-repeat;
	background-size: 100% 100%;

}

.points-body {
	text-align: center;
}

.points-image {
	width: 2.075rem;
	height: 2.075rem;
	object-fit: cover;
	display: inline-block;
}

.points-desc {
	font-size: .25rem;
	color: #2A2A2A;
}

.points-card .reward-btn {
	width: 2.0375rem;
	height: .4875rem;
	margin-left: .5375rem;
}

/* —— 移动端适配 —— */
@media (max-width: 768px) {
	.position .rewards-header {
		font-size: 12px;
		flex-direction: column;
		align-items: flex-start;
	}

	.position-conter {
		margin-left: -.1rem;
		width: 9.4267rem;
		height: 10.04rem;
		background: url(../assets/image/Loginbonus_m.png) no-repeat;
		background-size: 100% 100%;
	}

	.position .rewards-title {
		font-size: 18px;
	}

	.position .action-btn {
		font-size: .32rem;
		width: 2.0533rem;
		height: .64rem;
		line-height: .64rem;
	}

	.position .reward-card {
		width: 2.52rem;
		height: 7.7867rem;
	}

	.position .login-rewards {
		margin-top: 0.5rem;
		width: 68%;
		height: 8.3rem;
	}

	.position .card-image {
		width: 1.8133rem;
		height: 1.8133rem;
		object-fit: cover;
		display: inline-block;
	}

	.position .reward-btn {
		margin-left: .1467rem;
		margin-top: .5rem;
		width: 2.1867rem;
		height: .5333rem;
		color: #272727;
		line-height: .5333rem;
		border-radius: .1rem;
		font-size: .32rem;
	}

	.position .red-box .reward-btn {
		margin-top: .75rem;
	}


	.points-card {
		width: 4.0533rem;
		height: 4.3333rem;
	}

	.points-image {
		width: 2.6667rem;
		height: 2.6667rem;
	}

	.points-desc {
		font-size: .32rem;
		color: #2A2A2A;
	}

	.points-card .reward-btn {
		width: 2.6133rem;
		height: .6267rem;
		margin-top: .1rem;
		margin-left: .6933rem;
	}


}
</style>